/* ══════════════════════════════════════
   SOMO CUSTOM JS — Somotomox
   ══════════════════════════════════════ */

// SOMO Product Hero - Image Switching with Product Media
function swImg(thumb, index) {
  // Remove active class from all thumbs
  document.querySelectorAll('.somo-pthumb').forEach(el => el.classList.remove('active'));
  
  // Add active class to clicked thumb
  thumb.classList.add('active');
  
  // Get the image from thumbnail
  const thumbImg = thumb.querySelector('img');
  
  if (thumbImg) {
    const mainImg = document.getElementById('mainImg');
    
    if (mainImg) {
      // Try multiple methods to get the high-res version
      let highResSrc = thumbImg.src;
      
      // Method 1: Replace width parameter (handle both &width= and &amp;width=)
      if (highResSrc.includes('width=')) {
        highResSrc = highResSrc.replace(/&amp;width=\d+/, '&width=1200').replace(/&width=\d+/, '&width=1200');
      }
      // Method 2: If no width parameter, add it (handle Shopify CDN URLs)
      else if (highResSrc.includes('.jpg') || highResSrc.includes('.png') || highResSrc.includes('.webp')) {
        if (highResSrc.includes('?')) {
          highResSrc = highResSrc + '&width=1200';
        } else {
          highResSrc = highResSrc + '?width=1200';
        }
      }
      // Method 3: For Shopify CDN URLs with existing parameters
      else {
        highResSrc = thumbImg.src + '&width=1200';
      }
      
      // Update the main image
      mainImg.src = highResSrc;
      mainImg.alt = thumbImg.alt || 'Product Image';
      
      // Also update srcset to match the new image
      if (thumbImg.srcset) {
        const thumbSrcset = thumbImg.srcset;
        const highResSrcset = thumbSrcset.replace(/width=\d+/g, 'width=1200');
        mainImg.srcset = highResSrcset;
      }
      
      // Force image reload by adding timestamp
      const timestamp = new Date().getTime();
      mainImg.src = highResSrc + '&t=' + timestamp;
      if (mainImg.srcset) {
        mainImg.srcset = highResSrcset + '&t=' + timestamp;
      }
    }
  }
  
  // Update image counter
  const imgNum = document.getElementById('imgNum');
  if (imgNum) {
    imgNum.textContent = index + 1;
  }
}

// SOMO Product Hero - Variant Selection and Cart Functionality
function selectVariant(element, value, optionIndex) {
  // Update active color selection
  document.querySelectorAll('.somo-pcolor').forEach(el => el.classList.remove('active'));
  element.classList.add('active');
  
  // Update color name display
  const colorNameElement = document.getElementById('colorName');
  if (colorNameElement) {
    colorNameElement.textContent = value;
  }
  
  // Get all active color selections
  const activeColors = Array.from(document.querySelectorAll('.somo-pcolor.active'));
  const selectedOptions = activeColors.map(el => el.getAttribute('title'));
  
  // Find matching variant using data attributes or form data
  const variant = findVariantByOptions(selectedOptions);
  
  if (variant) {
    updateVariantDisplay(variant);
  }
}

function findVariantByOptions(options) {
  // Try to find variant from Shopify's product data
  const productData = window.ShopifyAnalytics?.product || window.product;
  
  if (productData && productData.variants) {
    for (let variant of productData.variants) {
      const matchesAll = options.every((opt, index) => 
        variant.options[index] === opt
      );
      
      if (matchesAll) {
        return variant;
      }
    }
  }
  
  // Fallback: try to find from form select
  const variantSelect = document.querySelector('select[name="id"]');
  
  if (variantSelect) {
    for (let option of variantSelect.options) {
      const optionText = option.text.toLowerCase();
      const matchesAll = options.every(opt => optionText.includes(opt.toLowerCase()));
      
      if (matchesAll) {
        // Parse variant data from option text if possible
        return {
          id: option.value,
          price: option.text.match(/\$\d+\.\d+/)?.[0] || '0.00',
          compare_at_price: option.text.match(/\$\d+\.\d+/g)?.[1] || null,
          available: !option.text.includes('Sold Out'),
          inventory_quantity: option.text.includes('In stock') ? 10 : 0
        };
      }
    }
  }
  
  return null;
}

function updateVariantDisplay(variant) {
  // Update form hidden input
  const variantInput = document.getElementById('form-variant-id');
  if (variantInput) {
    variantInput.value = variant.id;
  }
  
  // Update price
  const priceElement = document.querySelector('.somo-pprice');
  if (priceElement && variant.price) {
    // Shopify prices are in cents, convert to dollars and format with comma
    const priceInDollars = parseFloat(variant.price) / 100;
    const formattedPrice = '$' + priceInDollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    priceElement.textContent = formattedPrice;
  }
  
  // Update original price if exists
  const originalPriceElement = document.querySelector('.somo-pprice-orig');
  if (originalPriceElement && variant.compare_at_price && variant.compare_at_price > variant.price) {
    // Shopify prices are in cents, convert to dollars and format with comma
    const comparePriceInDollars = parseFloat(variant.compare_at_price) / 100;
    const formattedOriginalPrice = '$' + comparePriceInDollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    originalPriceElement.textContent = formattedOriginalPrice;
    originalPriceElement.style.display = '';
  } else if (originalPriceElement) {
    originalPriceElement.style.display = 'none';
  }
  
  // Update save amount
  const saveElement = document.querySelector('.somo-psave');
  if (saveElement && variant.compare_at_price && variant.compare_at_price > variant.price) {
    // Shopify prices are in cents, convert to dollars and format with comma
    const priceInDollars = parseFloat(variant.price) / 100;
    const comparePriceInDollars = parseFloat(variant.compare_at_price) / 100;
    const discount = comparePriceInDollars - priceInDollars;
    const formattedDiscount = 'Save $' + discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    saveElement.textContent = formattedDiscount;
    saveElement.style.display = '';
  } else if (saveElement) {
    saveElement.style.display = 'none';
  }
  
  // Update stock
  const stockElement = document.querySelector('.somo-pstock');
  if (stockElement) {
    if (variant.inventory_quantity > 0) {
      stockElement.textContent = `In stock: ${variant.inventory_quantity} available`;
      stockElement.style.color = '#4a9a5c';
    } else {
      stockElement.textContent = 'Out of stock';
      stockElement.style.color = '#dc3545';
    }
  }
  
  // Update button states
  const addToCartBtn = document.querySelector('.somo-patc');
  const buyNowBtn = document.querySelector('.somo-pbuynow');
  
  if (addToCartBtn) {
    if (variant.available) {
      addToCartBtn.disabled = false;
      const span = addToCartBtn.querySelector('span');
      if (span) span.textContent = 'Add to Cart';
    } else {
      addToCartBtn.disabled = true;
      const span = addToCartBtn.querySelector('span');
      if (span) span.textContent = 'Sold Out';
    }
  }
  
  if (buyNowBtn) {
    buyNowBtn.disabled = !variant.available;
  }
  
  // Update quantity input
  const qtyInput = document.querySelector('.somo-pqty-num');
  if (qtyInput) {
    qtyInput.disabled = !variant.available;
  }
  
  // Update main image if variant has specific image
  if (variant.featured_media && variant.featured_media.src) {
    const mainImg = document.getElementById('mainImg');
    if (mainImg) {
      let variantImageUrl = variant.featured_media.src;
      
      // Ensure the URL is properly formatted
      if (!variantImageUrl.startsWith('http')) {
        variantImageUrl = 'https:' + variantImageUrl;
      }
      
      // Convert to high-res version
      const highResVariantUrl = variantImageUrl.replace(/width=\d+/, 'width=1200');
      
      // Update both src and srcset
      mainImg.src = highResVariantUrl;
      mainImg.alt = variant.title || 'Product Image';
      
      // Clear srcset to avoid conflicts
      mainImg.srcset = '';
      
      // Force reload with timestamp
      const timestamp = new Date().getTime();
      mainImg.src = highResVariantUrl + '&t=' + timestamp;
      
      mainImg.onload = function() {
        // Variant image loaded successfully
      };
      mainImg.onerror = function() {
        // Failed to load variant image, keep current image
      };
    }
  }
}

// Enhanced quantity function
function chQty(delta) {
  const qtyInput = document.getElementById('qty');
  const formQtyInput = document.getElementById('form-quantity');
  const currentValue = parseInt(qtyInput.value) || 1;
  const newValue = Math.max(1, currentValue + delta);

  qtyInput.value = newValue;
  formQtyInput.value = newValue;
}

// ---- Add-ons ----
// Toggle an add-on card on/off
window.somoTogAddon = function(card) {
  if (!card) return;
  const on = card.classList.toggle('on');
  card.setAttribute('aria-checked', on ? 'true' : 'false');
  somoUpdateAddonStatus();
};

// Refresh the "None selected" / "X + Y added" status line
function somoUpdateAddonStatus() {
  const status = document.getElementById('somoAddonStatus');
  if (!status) return;
  const labels = [];
  document.querySelectorAll('.somo-paddon-card.on').forEach(function(c) {
    labels.push(c.getAttribute('data-addon-label'));
  });
  status.textContent = labels.length ? labels.join(' + ') + ' added' : 'None selected';
}

// Return [{id}] for each selected add-on (variant IDs for /cart/add.js)
window.somoGetSelectedAddons = function() {
  const arr = [];
  document.querySelectorAll('.somo-paddon-card.on').forEach(function(c) {
    const id = c.getAttribute('data-addon-id');
    if (id) arr.push({ id: id });
  });
  return arr;
};

// Keyboard support (Space/Enter toggles a focused add-on card)
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.somo-paddon-card').forEach(function(card) {
    if (card.dataset.somoBound) return; // avoid double-binding on repeated script loads
    card.dataset.somoBound = '1';
    card.addEventListener('keydown', function(e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        somoTogAddon(card);
      }
    });
  });
});

// Update cart count function
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update multiple possible cart counter selectors
      const cartCountSelectors = [
        '.cart-count',
        '.cart-count-bubble',
        '.cart-item-count',
        '[data-cart-count]',
        '.site-header__cart-count',
        '.header__cart-count',
        '.cart-count-number'
      ];
      
      let updated = false;
      cartCountSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (cart.item_count > 0) {
            element.textContent = cart.item_count;
            element.style.display = '';
          } else {
            element.style.display = 'none';
          }
          updated = true;
        });
      });
      
      // Update header cart counter specifically
      const headerCartCount = document.getElementById('header-cart-count');
      if (headerCartCount) {
        if (cart.item_count > 0) {
          headerCartCount.textContent = cart.item_count;
          headerCartCount.style.display = 'inline';
        } else {
          headerCartCount.style.display = 'none';
        }
        updated = true;
      }
      
      // If no standard selectors found, try to update via Shopify's cart system
      if (!updated && typeof Shopify !== 'undefined' && Shopify.onCartUpdate) {
        Shopify.onCartUpdate(cart);
      }
      
      // Trigger cart update event for other scripts
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Add to cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize gallery thumbnail clicks
  const thumbnails = document.querySelectorAll('.somo-pthumb');
  
  thumbnails.forEach((thumb, index) => {
    // Add click event listener
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      swImg(thumb, index);
    });
    
    // Also test onclick directly (backup method)
    thumb.onclick = function(e) {
      swImg(this, index);
      return false;
    };
  });
  
  const addToCartBtn = document.querySelector('.somo-patc');
  const buyNowBtn = document.querySelector('.somo-pbuynow');

  // Guard: somo-custom.js is included by multiple sections/layout, so this
  // DOMContentLoaded can run more than once. Only bind the handlers a single time.
  if (addToCartBtn && !addToCartBtn.dataset.somoBound) {
    addToCartBtn.dataset.somoBound = '1';
    addToCartBtn.addEventListener('click', function() {
      const form = document.getElementById('product-form');
      if (form) {
        // Update quantity before submit
        const formQtyInput = document.getElementById('form-quantity');
        const qtyInput = document.getElementById('qty');
        if (formQtyInput && qtyInput) {
          formQtyInput.value = qtyInput.value;
        }
        
        // Disable button during processing
        addToCartBtn.disabled = true;
        const originalText = addToCartBtn.querySelector('span').textContent;
        addToCartBtn.querySelector('span').textContent = 'Adding...';
        
        // Build items: bed + any selected add-ons
        var bedId = document.getElementById('form-variant-id').value;
        var bedQty = parseInt(document.getElementById('qty').value, 10) || 1;
        var items = [{ id: bedId, quantity: bedQty }];
        (window.somoGetSelectedAddons ? somoGetSelectedAddons() : []).forEach(function(a) {
          items.push({ id: a.id, quantity: 1 });
        });

        // Submit via fetch API
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: items }),
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === 422) {
            // Handle error
            addToCartBtn.querySelector('span').textContent = data.description || 'Error';
            setTimeout(() => {
              addToCartBtn.disabled = false;
              addToCartBtn.querySelector('span').textContent = originalText;
            }, 2000);
          } else {
            // Success - update cart count
            updateCartCount();
            
            // Show success message
            addToCartBtn.querySelector('span').textContent = 'Added!';
            setTimeout(() => {
              addToCartBtn.disabled = false;
              addToCartBtn.querySelector('span').textContent = originalText;
            }, 2000);
            
            // Optional: Open cart drawer if available
            if (typeof openCartDrawer === 'function') {
              openCartDrawer();
            }
            
            // Trigger Shopify cart update event
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          addToCartBtn.querySelector('span').textContent = 'Error';
          setTimeout(() => {
            addToCartBtn.disabled = false;
            addToCartBtn.querySelector('span').textContent = originalText;
          }, 2000);
        });
      }
    });
  }
  
  if (buyNowBtn && !buyNowBtn.dataset.somoBound) {
    buyNowBtn.dataset.somoBound = '1';
    buyNowBtn.addEventListener('click', function() {
      const form = document.getElementById('product-form');
      if (!form) return;

      // Update quantity before submit
      document.getElementById('form-quantity').value = document.getElementById('qty').value;

      var addons = window.somoGetSelectedAddons ? somoGetSelectedAddons() : [];
      if (addons.length === 0) {
        // No add-ons — keep default behaviour
        form.submit();
        return;
      }

      // With add-ons: add bed + add-ons to cart, then go to checkout
      var bedId = document.getElementById('form-variant-id').value;
      var bedQty = parseInt(document.getElementById('qty').value, 10) || 1;
      var items = [{ id: bedId, quantity: bedQty }];
      addons.forEach(function(a) { items.push({ id: a.id, quantity: 1 }); });

      buyNowBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) { return r.json(); })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() { buyNowBtn.disabled = false; window.location.href = '/cart'; });
    });
  }
});

// SOMO Scroll Reveal Animations
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('somo-revealed');
      }
    });
  }, observerOptions);

  // Observe elements with reveal classes
  document.querySelectorAll('.somo-rv, .somo-rvl, .somo-rvr').forEach(el => {
    observer.observe(el);
  });
});

// Video hover unmute functionality
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.somo-vc').forEach(video => {
    video.addEventListener('mouseenter', () => {
      video.muted = false;
    });
    
    video.addEventListener('mouseleave', () => {
      video.muted = true;
    });
  });
});

// Scroll Reveal
(function() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('somo-on');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.somo-rv, .somo-rvl, .somo-rvr').forEach(function(el) {
    io.observe(el);
  });
})();

// Video hover unmute — desktop only
if (!('ontouchstart' in window)) {
  document.querySelectorAll('.somo-vc').forEach(function(card) {
    var video = card.querySelector('video');
    if (video) {
      card.addEventListener('mouseenter', function() { video.muted = false; });
      card.addEventListener('mouseleave', function() { video.muted = true; });
    }
  });
}

// ══════════════════════════════════════
// SOMO PRODUCT IMAGE ZOOM & LIGHTBOX
// ══════════════════════════════════════

(function() {
  var pmain = document.querySelector('.somo-pmain');
  if (!pmain) return;

  var mainImg = document.getElementById('mainImg');
  var isZooming = false;

  // --- Mouse-position zoom on hover ---
  pmain.addEventListener('mouseenter', function() {
    isZooming = true;
    pmain.classList.add('zooming');
  });

  pmain.addEventListener('mousemove', function(e) {
    if (!isZooming || !mainImg) return;
    var rect = pmain.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    mainImg.style.transformOrigin = x + '% ' + y + '%';
  });

  pmain.addEventListener('mouseleave', function() {
    isZooming = false;
    pmain.classList.remove('zooming');
    if (mainImg) mainImg.style.transformOrigin = 'center center';
  });

  // --- Lightbox ---
  var plbCurrentIndex = 0;
  var plbImages = [];

  // Build image list from product media thumbnails
  function buildPlbImages() {
    plbImages = [];
    document.querySelectorAll('.somo-pthumb img').forEach(function(img) {
      var src = img.src;
      if (src.includes('width=')) {
        src = src.replace(/&amp;width=\d+/, '&width=1200').replace(/&width=\d+/, '&width=1200');
      }
      plbImages.push({ src: src, alt: img.alt || 'Product Image' });
    });
    // If no thumbs, use main image
    if (plbImages.length === 0 && mainImg) {
      plbImages.push({ src: mainImg.src, alt: mainImg.alt });
    }
  }

  // Click main image to open lightbox
  pmain.addEventListener('click', function(e) {
    // Don't open lightbox if clicking badges/counter
    if (e.target.closest('.somo-pmain-badge, .somo-pmain-sale, .somo-pmain-counter')) return;
    buildPlbImages();
    // Determine current index from active thumb
    var activeThumbs = document.querySelectorAll('.somo-pthumb');
    plbCurrentIndex = 0;
    activeThumbs.forEach(function(t, i) {
      if (t.classList.contains('active')) plbCurrentIndex = i;
    });
    somoPlbOpen(plbCurrentIndex);
  });

  // Lightbox open/close/nav - global functions
  window.somoPlbOpen = function(index) {
    var lb = document.getElementById('somoPlb');
    if (!lb || plbImages.length === 0) return;
    plbCurrentIndex = index;
    updatePlbImage();
    lb.classList.add('open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  window.somoPlbClose = function() {
    var lb = document.getElementById('somoPlb');
    if (!lb) return;
    lb.classList.remove('open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  window.somoPlbNav = function(dir) {
    if (plbImages.length === 0) return;
    plbCurrentIndex = (plbCurrentIndex + dir + plbImages.length) % plbImages.length;
    updatePlbImage();
  };

  function updatePlbImage() {
    var img = document.getElementById('somoPlbImg');
    var counter = document.getElementById('somoPlbNum');
    if (img && plbImages[plbCurrentIndex]) {
      img.src = plbImages[plbCurrentIndex].src;
      img.alt = plbImages[plbCurrentIndex].alt;
    }
    if (counter) counter.textContent = plbCurrentIndex + 1;
  }

  // Close on backdrop click
  var lb = document.getElementById('somoPlb');
  if (lb) {
    lb.addEventListener('click', function(e) {
      if (e.target === lb) somoPlbClose();
    });
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    var lb = document.getElementById('somoPlb');
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape') somoPlbClose();
    if (e.key === 'ArrowLeft') somoPlbNav(-1);
    if (e.key === 'ArrowRight') somoPlbNav(1);
  });
})();

// ══════════════════════════════════════
// SOMO PRODUCT DETAILS ACCORDION
// ══════════════════════════════════════

// Accordion toggle function (simple like original HTML)
function togPdAcc(el) {
  var item = el.closest('.somo-pd-acc-item');
  item.classList.toggle('open');
}

// ══════════════════════════════════════
// SOMO ENGINEERED COMFORT CAROUSEL
// ══════════════════════════════════════

// SOMO Engineered Comfort Carousel
function somoEngSlide(d) {
  if (window.innerWidth < 768) return;
  const track = document.getElementById('somoEngTrack');
  if (!track) return;
  
  const cards = track.querySelectorAll('.somo-eng-card');
  const total = cards.length;
  const visible = window.innerWidth < 1024 ? 2 : 4;
  const max = total - visible;
  
  // Update current index
  if (!window.somoEngIndex) window.somoEngIndex = 0;
  window.somoEngIndex += d;
  
  // Boundary checks
  if (window.somoEngIndex < 0) window.somoEngIndex = max;
  if (window.somoEngIndex > max) window.somoEngIndex = 0;
  
  // Transform track
  const cardWidth = cards[0].offsetWidth + 20;
  track.style.transform = `translateX(-${window.somoEngIndex * cardWidth}px)`;
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  const track = document.getElementById('somoEngTrack');
  if (track) {
    window.somoEngIndex = 0;
    
    // Handle resize
    window.addEventListener('resize', function() {
      window.somoEngIndex = 0;
      if (window.innerWidth < 768) {
        track.style.transform = '';
      } else {
        somoEngSlide(0);
      }
    });
  }
});

// ══════════════════════════════════════
// SOMO FAQ ACCORDION TOGGLE
// ══════════════════════════════════════

// FAQ toggle function (simple like original HTML)
function togFaq(btn) {
  var item = btn.parentElement;
  var open = item.classList.contains('open');
  item.classList.toggle('open', !open);
}

// ══════════════════════════════════════
// SOMO STICKY ATC TOGGLE
// ══════════════════════════════════════

// Toggle sticky ATC visibility based on scroll
function somoToggleStickyATC() {
  const satc = document.getElementById('somo-satc');
  if (!satc) return;

  let lastScrollY = window.scrollY;
  let isVisible = false;

  function updateVisibility() {
    const currentScrollY = window.scrollY;
    const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';

    // Show ATC when scrolling down, hide when scrolling up
    if (scrollDirection === 'down' && currentScrollY > 200 && !isVisible) {
      satc.classList.add('visible');
      isVisible = true;
    } else if (scrollDirection === 'up' && isVisible) {
      satc.classList.remove('visible');
      isVisible = false;
    }

    lastScrollY = currentScrollY;
  }

  // Throttle scroll events
  let ticking = false;
  function requestTick() {
    updateVisibility();
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(requestTick);
      ticking = true;
    }
  });

  // Initial check
  updateVisibility();
}

// Initialize sticky ATC toggle
document.addEventListener('DOMContentLoaded', function() {
  somoToggleStickyATC();
});

// ══════════════════════════════════════
// SOMO MOBILE CTA VARIANT SYNC
// ════════════════════════════════════

// Update mobile CTA when variant changes
function updateMobileCTC(variant) {
  const priceMain = document.querySelector('.somo-price-main');
  const priceOrig = document.querySelector('.somo-price-orig');
  const priceSave = document.querySelector('.somo-price-save');
  const variantId = document.querySelector('.somo-mob-variant-id');
  
  if (!priceMain || !variantId) return;
  
  // Update price using manual formatting (cents to dollars)
  const price = (variant.price / 100).toFixed(2);
  priceMain.textContent = '$' + price;
  
  // Update variant ID
  variantId.value = variant.id;
  
  // Update original price and save amount if on sale
  if (variant.compare_at_price > variant.price) {
    if (priceOrig) {
      const origPrice = (variant.compare_at_price / 100).toFixed(2);
      priceOrig.textContent = '$' + origPrice;
      priceOrig.style.display = '';
    }
    if (priceSave) {
      const savings = ((variant.compare_at_price - variant.price) / 100).toFixed(2);
      priceSave.textContent = 'Save $' + savings;
      priceSave.style.display = '';
    }
  } else {
    if (priceOrig) priceOrig.style.display = 'none';
    if (priceSave) priceSave.style.display = 'none';
  }
}

// Connect to existing selectVariant function from product hero
document.addEventListener('DOMContentLoaded', function() {
  // Store original updateVariantDisplay function if it exists
  const originalUpdateVariantDisplay = window.updateVariantDisplay;
  
  // Override updateVariantDisplay to also update mobile CTA
  window.updateVariantDisplay = function(variant) {
    // Call original function first
    if (originalUpdateVariantDisplay) {
      originalUpdateVariantDisplay(variant);
    }
    
    // Update mobile CTA
    updateMobileCTC(variant);
  };
  
  // Initialize with current variant
  if (window.product && window.product.selected_or_first_available_variant) {
    updateMobileCTC(window.product.selected_or_first_available_variant);
  }
  
  // Check if product hero is visible and hide/show mobile CTA accordingly
  function checkProductHeroVisibility() {
    const productHero = document.querySelector('.somo-phero');
    const mobileCTA = document.querySelector('.somo-mob-cta');
    
    if (productHero && mobileCTA) {
      const rect = productHero.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      
      // Hide mobile CTA when product hero is visible
      if (isVisible) {
        mobileCTA.classList.add('hidden');
      } else {
        mobileCTA.classList.remove('hidden');
      }
    }
  }
  
  // Check visibility on scroll and resize
  let ticking = false;
  function requestTick() {
    checkProductHeroVisibility();
    ticking = false;
  }
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(requestTick);
      ticking = true;
    }
  });
  
  window.addEventListener('resize', function() {
    if (!ticking) {
      requestAnimationFrame(requestTick);
      ticking = true;
    }
  });
  
  // Initial check
  checkProductHeroVisibility();
});

// ══════════════════════════════════════
// SOMO REVIEWS MARQUEE CONTROLS
// ══════════════════════════════════════

// SOMO Reviews Marquee Control
document.addEventListener('DOMContentLoaded', function() {
  const marqueeWraps = document.querySelectorAll('.somo-reviews-marquee-wrap');

  // Pause on hover
  marqueeWraps.forEach(wrap => {
    const tracks = wrap.querySelectorAll('.somo-reviews-track, .somo-reviews-track-rev');
    
    wrap.addEventListener('mouseenter', () => {
      tracks.forEach(track => track.style.animationPlayState = 'paused');
    });
    
    wrap.addEventListener('mouseleave', () => {
      tracks.forEach(track => track.style.animationPlayState = 'running');
    });
  });
  
  // Mobile swipe support
  const swipeWraps = document.querySelectorAll('.somo-reviews-swipe-wrap');
  swipeWraps.forEach(wrap => {
    let isDown = false;
    let startX;
    let scrollLeft;
    
    const strip = wrap.querySelector('.somo-reviews-swipe-strip');
    
    strip.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - strip.offsetLeft;
      scrollLeft = strip.scrollLeft;
    });
    
    strip.addEventListener('mouseleave', () => {
      isDown = false;
    });
    
    strip.addEventListener('mouseup', () => {
      isDown = false;
    });
    
    strip.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - strip.offsetLeft;
      const walk = (x - startX) * 2;
      strip.scrollLeft = scrollLeft - walk;
    });
  });
});


// ============================================
// SOMO FAQ Accordion Toggle
// ============================================
function somoToggleFaq(element) {
  const item = element.closest('.somo-faq-item');
  item.classList.toggle('open');
}


// ============================================
// SOMO FAQ Tab Switching
// ============================================
function somoSwitchTab(tabId) {
  // Remove active from all tabs and content
  document.querySelectorAll('.somo-faq-cat-btn').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.somo-faq-tab-content').forEach(content => content.classList.remove('active'));
  
  // Add active to clicked tab and corresponding content
  document.querySelector('[data-tab="' + tabId + '"]').classList.add('active');
  document.getElementById('tab-' + tabId).classList.add('active');
}


// Privacy Policy TOC Active State on Scroll
(function() {
  const sections = document.querySelectorAll('.somo-pp-section[id]');
  const tocLinks = document.querySelectorAll('.somo-pp-toc-list a');
  
  if (sections.length === 0 || tocLinks.length === 0) return;

  function setActiveLink() {
    let currentSection = '';
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      
      if (window.pageYOffset >= sectionTop - 150) {
        currentSection = section.getAttribute('id');
      }
    });
    
    tocLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === '#' + currentSection) {
        link.classList.add('active');
      }
    });
  }

  window.addEventListener('scroll', setActiveLink);
  window.addEventListener('load', setActiveLink);
})();

// Mobile Menu Toggle
function toggleMobileMenu() {
  console.log('Toggle mobile menu called');
  const mobileMenu = document.getElementById('mobileMenu');
  console.log('Mobile menu element:', mobileMenu);
  
  if (mobileMenu) {
    mobileMenu.classList.toggle('active');
    console.log('Toggled active class. Current classes:', mobileMenu.className);
    
    // Prevent body scroll when menu is open
    if (mobileMenu.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
      console.log('Menu opened, body scroll locked');
    } else {
      document.body.style.overflow = '';
      console.log('Menu closed, body scroll unlocked');
    }
  } else {
    console.error('Mobile menu element not found');
  }
}

// Close mobile menu when clicking outside
document.addEventListener('click', function(event) {
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuBtn = document.querySelector('.somo-mobile-menu-btn');
  
  if (mobileMenu && mobileMenu.classList.contains('active') && 
      !mobileMenu.contains(event.target) && 
      !mobileMenuBtn.contains(event.target)) {
    toggleMobileMenu();
  }
});

// Close mobile menu when clicking on a link
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, setting up mobile menu links');
  const mobileMenuLinks = document.querySelectorAll('.somo-mobile-menu-list a, .somo-mobile-menu-link');
  console.log('Found mobile menu links:', mobileMenuLinks.length);
  
  mobileMenuLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      const mobileMenu = document.getElementById('mobileMenu');
      if (mobileMenu && mobileMenu.classList.contains('active')) {
        toggleMobileMenu();
      }
    });
  });
});
